var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonSort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8178 6.03385C15.2031 6.03394 15.5154 6.34637 15.5153 6.73169L15.5123 19.3023C15.5122 19.6876 15.1998 19.9999 14.8145 19.9998C14.4292 19.9997 14.1169 19.6873 14.117 19.302L14.12 6.73136C14.12 6.34605 14.4325 6.03376 14.8178 6.03385Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85214 14.7791C10.11 14.4928 10.5512 14.4698 10.8375 14.7276L14.8364 18.3296L18.8354 14.7276C19.1217 14.4698 19.5628 14.4928 19.8207 14.7791C20.0785 15.0654 20.0555 15.5065 19.7692 15.7644L15.3033 19.787C15.0379 20.026 14.6349 20.026 14.3695 19.787L9.9036 15.7644C9.6173 15.5065 9.59427 15.0654 9.85214 14.7791Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.697669C0 0.312357 0.312357 0 0.69767 0H18.8515C19.2368 0 19.5491 0.312357 19.5491 0.697669C19.5491 1.08298 19.2368 1.39534 18.8515 1.39534H0.69767C0.312357 1.39534 0 1.08298 0 0.697669Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.7316C0 6.34629 0.312357 6.03394 0.69767 6.03394H9.77457C10.1599 6.03394 10.4722 6.34629 10.4722 6.7316C10.4722 7.11692 10.1599 7.42927 9.77457 7.42927H0.69767C0.312357 7.42927 0 7.11692 0 6.7316Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.7712C0 13.3858 0.312357 13.0735 0.69767 13.0735H5.74039C6.1257 13.0735 6.43806 13.3858 6.43806 13.7712C6.43806 14.1565 6.1257 14.4688 5.74039 14.4688H0.69767C0.312357 14.4688 0 14.1565 0 13.7712Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonSort);
export default __webpack_public_path__ + "static/media/button_sort.0ebe166430305300e0f8e69f935aac06.svg";
export { ForwardRef as ReactComponent };